import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { SPECIES_API } from './config';

export function getList(query) {
  return getFetch(`${SPECIES_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${SPECIES_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${SPECIES_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${SPECIES_API()}/${_id}`);
}

export function create(data) {
  return postFetch(`${SPECIES_API()}`, data);
}

export function exportData(query) {
  return getFetch(`${SPECIES_API()}/export`, query);
}



// WEBPACK FOOTER //
// ./src/api/speciesApi.js